
if (module.hot) {
    console.log("[hot] Reload!");
    module.hot.accept();
}
